interface DomainMap<T> {
  [key: string]: T;
}
export const domainMap: DomainMap<string> = {
  // dev
  "app-crm.city.ispgnet.com": "api-crm.city.ispgnet.com",

  // preprod
  "qa-crm.cityinfoservices.com": "api-qa-crm.cityinfoservices.com",

  // master
  "crm.cityinfoservices.com": "api-crm.cityinfoservices.com",

  // staging
  "app-crm-staging.city.ispgnet.com": "api-crm-staging.city.ispgnet.com",

  // testing
  "city-crm-prod-test.ispgnet.com": "api-cityinfo-crm-test.ispgnet.com",
};
